import styled from '@emotion/styled';
import ImageComponent from '@kyruus/image-component';
import { fromTheme } from '@kyruus/ui-theme';
import {
  BREAKPOINTS,
  PROFILE_IMAGE_MAX_HEIGHT,
  PROFILE_IMAGE_MAX_HEIGHT_MOBILE,
  PROFILE_IMAGE_MAX_WIDTH
} from '../../lib/constants';

type ProviderImgWrapperType = {
  isCircle: boolean;
  imageHeight?: number;
  isLandscape: boolean;
};

export const ProviderImgWrapper = styled.div<ProviderImgWrapperType>`
  width: fit-content;
  height: fit-content;
  // Prevent empty space in container for circular landscape images
  max-width: ${({ isCircle, isLandscape, imageHeight }) =>
    isCircle && isLandscape ? `${imageHeight}px` : PROFILE_IMAGE_MAX_WIDTH};
  overflow: hidden;

  border: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_image_placeholder')};
  background: ${(props) => fromTheme('color_image_placeholder')(props)};
  aspect-ratio: ${({ isCircle }) => (isCircle ? '1' : 'auto')};
  border: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_image_placeholder')};
  border-radius: ${(props) =>
    fromTheme('provider_profile_provider_image_border_radius')(props) ||
    'unset'};

  @media screen and (max-width: ${BREAKPOINTS.small}px) {
    align-self: center;
    margin: ${fromTheme('spacing_medium')} 0 0;
  }

  // position next to name/specialties/badges on screens between small and medium width
  @media screen and (min-width: ${BREAKPOINTS.small}px) {
    flex: 0 0 auto;
  }
`;
type ProviderImgType = {
  isCircle: boolean;
  isLandscape: boolean;
};

export const ProviderImg = styled(ImageComponent)<ProviderImgType>`
  width: auto;
  max-width: ${PROFILE_IMAGE_MAX_WIDTH};
  height: auto;
  object-fit: cover;
  // Prevent empty space in container for circular landscape images
  max-height: ${({ isCircle, isLandscape }) =>
    isCircle && isLandscape ? 'none' : PROFILE_IMAGE_MAX_HEIGHT};
  // override the default border radius for the image
  border-radius: unset !important;

  @media screen and (max-width: ${BREAKPOINTS.small}px) {
    max-height: ${({ isCircle, isLandscape }) =>
      isCircle && isLandscape ? 'none' : PROFILE_IMAGE_MAX_HEIGHT_MOBILE};
  }
`;
